import axios from "axios";

const actionGetResults = async ({commit}, payload) => {
  const results = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/lact_del`, {params:payload});
  commit("SET_LACTATION_CURVE_RESULTS", results.data);
}

export default {
  actionGetResults
}